import { Box, type BoxProps } from '@mui/material';
import { DeepSyncMark } from './DeepSyncMark';

interface Props {
  size?: number;
  label?: string;
  color?: string;
  sx?: BoxProps['sx'];
  className?: string;
}

export function DeepSyncSpinner({
  size = 20,
  label = 'Loading',
  color,
  sx,
  className,
}: Props) {
  return (
    <Box component="span" sx={{ display: 'inline-flex', ...(sx as Record<string, unknown> | undefined) } as BoxProps['sx']} className={className}>
      <DeepSyncMark size={size} variant="spin" color={color} title={label} />
    </Box>
  );
}
